import React, { useState } from 'react';
import { toast } from 'react-toastify';
import GenericModal from '../../../components/modal/GenericModal';
import { usePostRequest } from '../../../hooks/usePostRequest/usePostRequest';
import { useSubmitForm } from '../../../hooks/useSubmitForm/useSubmitForm';
import { responseCode200, mostrarMensajeDeErrorConToast } from '../../../consumers/httpRequiestsUtils';
import { buscarColaboradorPrestamoAPI, reasignarSolicitudPrestamoAprobacionAPI } from '../../../consumers/backendApisUrls';
import { isEmpty } from '../../../helper/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ReasignarAprobadorPrestamo = ({
    toggleModal,
    refreshPage,
    idSolicitud,
    nombreEmpleado,
    nombreEmpleadoAprobador
}) => {
    const KEYS = ["IdEmpleadoAprobador"];
    const SECTION_NAME = "ReasignarAprobador";

    const [criterioBusqueda, setCriterioBusqueda]       = useState("");
    const [cargandoEmpleados, setCargandoEmpleados]     = useState(false);
    const [empleadosOptions, setEmpleadosOptions]       = useState([]);
    const [selectedAprobador, setSelectedAprobador]     = useState(null);
    const [enviando, setEnviando]                       = useState(false);

    const [executePostRequest] = usePostRequest();
    const [submitForm]         = useSubmitForm();

    const handleKeypress = (e) => {
        if (e.key === 'Enter') buscarEmpleado();
    };

    const buscarEmpleado = async () => {
        if (isEmpty(criterioBusqueda)) {
            toast.warn("Ingrese un criterio de búsqueda.");
            return;
        }
        setCargandoEmpleados(true);
        setEmpleadosOptions([]);
        setSelectedAprobador(null);
        try {
            const response = await executePostRequest(
                buscarColaboradorPrestamoAPI(),
                { Criteria: criterioBusqueda }
            );
            if (responseCode200(response)) {
                const options = (response.data ?? []).map(o => ({
                    value: o.Value,
                    label: o.Text
                }));
                setEmpleadosOptions(options);
            } else {
                mostrarMensajeDeErrorConToast(response);
            }
        } finally {
            setCargandoEmpleados(false);
        }
    };

    const getPayload = () => ({
        IdSolicitud:         idSolicitud,
        IdEmpleadoAprobador: selectedAprobador?.value ?? null
    });

    const successReasignarCallback = () => {
        toggleModal();
        refreshPage();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selectedAprobador?.value) {
            toast.warn("Debe seleccionar un nuevo aprobador.");
            return;
        }
        try {
            setEnviando(true);
            const api     = reasignarSolicitudPrestamoAprobacionAPI();
            const payload = getPayload();
            await submitForm(KEYS, api, payload, SECTION_NAME, successReasignarCallback);
        } catch (error) {
            console.error(error);
        } finally {
            setEnviando(false);
        }
    };

    return (
        <GenericModal showModal={toggleModal} titulo="Reasignar Aprobador de Préstamo" width="600px">
            <div className="modal-body">
                <form>
                    {/* ── Solicitante (solo lectura) ── */}
                    <div className="form-row mb-1">
                        <div className="form-group col-sm-12">
                            <label className="modal-label mb-0">Solicitante</label>
                            <input type="text" className="form-control"
                                value={nombreEmpleado ?? ""} disabled />
                        </div>
                    </div>

                    {/* ── Aprobador actual (solo lectura) ── */}
                    <div className="form-row mb-1">
                        <div className="form-group col-sm-12">
                            <label className="modal-label mb-0">Aprobador Actual</label>
                            <input type="text" className="form-control"
                                value={nombreEmpleadoAprobador ?? ""} disabled />
                        </div>
                    </div>

                    {/* ── Buscador nuevo aprobador ── */}
                    <div className="form-row mb-1">
                        <div className="form-group col-sm-12">
                            <label className="modal-label mb-0">
                                Nuevo Aprobador <span className="required">*</span>
                            </label>
                            <div className="d-flex">
                                <input
                                    type="text"
                                    className="form-control mr-2"
                                    placeholder="Nombre, Apellidos o DNI"
                                    value={criterioBusqueda}
                                    onChange={e => setCriterioBusqueda(e.target.value)}
                                    onKeyPress={handleKeypress}
                                />
                                <button type="button"
                                    className="btn btn-primary generic-button-ficha-modal"
                                    onClick={buscarEmpleado}
                                    disabled={cargandoEmpleados}>
                                    {cargandoEmpleados
                                        ? <FontAwesomeIcon icon="spinner" className="spinner" />
                                        : "Buscar"}
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* ── Resultados búsqueda ── */}
                    {empleadosOptions.length > 0 && (
                    <div className="form-row mb-2">
                        <div className="form-group col-sm-12">
                            <select className="form-control"
                                value={selectedAprobador?.value ?? ""}
                                onChange={e => {
                                    const selected = empleadosOptions.find(
                                        o => o.value === Number(e.target.value));
                                    setSelectedAprobador(selected ?? null);
                                }}>
                                <option value="" disabled>Seleccione el nuevo aprobador...</option>
                                {empleadosOptions.map(o => (
                                    <option key={o.value} value={o.value}>{o.label}</option>
                                ))}
                            </select>
                            <p className="ficha-form-input-validation-message"
                               id={`ficha-edit-${SECTION_NAME}-IdEmpleadoAprobador-validation-message`}></p>
                        </div>
                    </div>
                    )}

                    {/* ── Footer ── */}
                    <div className="modal-footer pl-0 justify-content-end">
                        <button type="button"
                            className="btn btn-secondary mr-2"
                            onClick={toggleModal}
                            disabled={enviando}>
                            Cancelar
                        </button>
                        <button type="button"
                            className="generic-button-buscador"
                            onClick={handleSubmit}
                            disabled={enviando || !selectedAprobador}>
                            {enviando ? "Guardando..." : "Guardar"}
                        </button>
                    </div>
                </form>
            </div>
        </GenericModal>
    );
};

export default ReasignarAprobadorPrestamo;
